import { QueryDataSource } from '@softapps/core';
import {
  ApiDataAccess,
  ApiResourceLocation,
  HttpApiQueryRepository,
  Query,
} from '@softline/core';
import { SALES_STATISTICS_PER_TYPE } from '../sales-statistics.api';
import { AbortableApiDataAccess } from '@softline/core';

export class SalesStatisticsGridDataSource
  extends HttpApiQueryRepository<object>
  implements QueryDataSource<object>
{
  type = 'query' as const;

  constructor(
    dataAccess: ApiDataAccess,
    documentType: string,
    statisticType: string
  ) {
    super(
      dataAccess,
      SALES_STATISTICS_PER_TYPE.replace('{documentType}', documentType).replace(
        '{statisticType}',
        statisticType
      )
    );
  }

  loadAbortable(
    params: { query: Query<object> },
    signal?: AbortSignal,
  ): Promise<{ data: object[] }> {
    if (!signal || !(this.dataAccess instanceof AbortableApiDataAccess)) {
      return this.load(params) as Promise<{ data: object[] }>;
    }
    const location: ApiResourceLocation = {
      path: Array.isArray(this.path) ? this.path : [this.path],
    };
    return this.dataAccess.getAbortable<{ data: object[] }>(location, params.query, signal);
  }
}
